import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LatestJoblogPackage } from '../interfaces/latest-joblog-package.interface';
import { PagedResult } from '../link/link-joblog-searcher-admin/link-joblog-search-admin/link-joblog-search-admin.component';

export interface LogRow {
  id: number;
  creationDate: string;
  message: string;

  fromApplicationId?: number | null;
  toApplicationId?: number | null;

  linkTypeId?: number | null;
}

export interface PatternSearchRequest {
  terms: string[];
  chunks: string[];
  take: number;
  skip: number;
  linkId?: number | null;
  jobLogType?: number | null;
  fromApplicationId: number | null;
  toApplicationId: number | null;
}

@Injectable({
  providedIn: 'root',
})
export class JobLogService {
  readonly url: string = 'JobLog';
  constructor(private http: HttpClient) { }

  public get(instanceId: string): Observable<any> {
    return this.http.get<any>(this.url + '/getJobFields/' + instanceId);
  }

  public getLatestFieldsByLogType(latestJoblogPackage: LatestJoblogPackage): Observable<any> {
    return this.http.post<any>(this.url + '/getNewJobFieldsById', latestJoblogPackage);
  }

  searchByUserPattern(req: {
    terms: string[];
    chunks: string[];
    take: number;
    skip: number;
    linkId: number | null;
    jobLogType: number | null;
    fromApplicationId: number | null;
    toApplicationId: number | null;
    linkTypeId: number | null;
    includeTotal: boolean;
    uniqueOnly: boolean;
  }): Observable<PagedResult<LogRow>> {
    return this.http.post<PagedResult<LogRow>>('/api/JobLog/search-by-user-pattern', req);
  }
}
